exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".profitAndLossChart-944d8{width:66%}.tooltipWrapper-56eee{border-radius:8px}.tooltipLabel-bce46{color:#262626}", ""]);

// Exports
exports.locals = {
	"profitAndLossChart": "profitAndLossChart-944d8",
	"tooltipWrapper": "tooltipWrapper-56eee",
	"tooltipLabel": "tooltipLabel-bce46"
};